import SEOHelmet from './SEOHelmet';

export default SEOHelmet;
